module.exports = __webpack_public_path__ + "static/logo-white-f98266577589469498c5f34d8d63cb36.png";